import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import SubmitButton from "../Common/buttons/SubmitButton";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import { ApiHook } from "../../hooks/apiHook";
import { ConfigProvider, Flex, Radio } from "antd";
import { useIsFetching } from '@tanstack/react-query';
import { setUserDefaultPlan } from "../../utils/defaultPlan";


const TreeViewNavbar = ({ menu, searchUsername, setSearchUsername, setSelectedUserId, treePlan, setTreePlan }) => {
  const isSponsorTreeLoading = useIsFetching({ queryKey: ["get-sponsor-tree-more"] });
  const isGenealogyTreeLoading = useIsFetching({ queryKey: ["genealogy-tree-list"] });
  const isSponsorTreeByIdLoading = useIsFetching({ queryKey: ["sponsor-tree-list-byid"] });
  const isGetSponsorTreeMoreLoading = useIsFetching({ queryKey: ["get-sponsor-tree-more"] });
  const isTreeViewListLoading = useIsFetching({ queryKey: ["tree-view-list"] });
  const isGenealogyUnilevelMoreLoading = useIsFetching({ queryKey: ["genealogy-unilevel-more"] });
  const isDownlineMembersLoading = useIsFetching({ queryKey: ["downlinemember"] });
  const isDownlineHeadLoading = useIsFetching({ queryKey: ["downlinehead"] });
  const isReferralMembersLoading = useIsFetching({ queryKey: ["referralmembers"] });
  const isReferralHeadLoading = useIsFetching({ queryKey: ["referralhead"] });


  const isLoading = (
    isSponsorTreeLoading > 0 ||
    isGenealogyTreeLoading > 0 ||
    isSponsorTreeByIdLoading > 0 ||
    isGetSponsorTreeMoreLoading > 0 ||
    isTreeViewListLoading > 0 ||
    isGenealogyUnilevelMoreLoading > 0 ||
    isDownlineMembersLoading > 0 ||
    isDownlineHeadLoading > 0 ||
    isReferralMembersLoading > 0 ||
    isReferralHeadLoading > 0
  )

  const handleTreePlanChange = (selectedOption) => {
    if (location.pathname === "/sponsor-tree" || location.pathname === "/genealogy-tree") {
      handleReset();
    }
    setUserDefaultPlan(selectedOption);
    setTreePlan(selectedOption);
  };
  const userPlans = useSelector((state) => {
    return state.dashboard?.appLayout?.userplans;
  });
  const [defaultPlan, setDefaultPlan] = useState(userPlans?.defaultPlan);
  useEffect(() => {
    setDefaultPlan(userPlans?.defaultPlan);
  }, [userPlans]);
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;
  const [username, setUsername] = useState("");
  const [selectedMenu, setSelectedMenu] = useState(false);
  if (location.pathname === "/sponsor-tree") {
    ApiHook.CallSponsorTreeList(treePlan, "", "", searchUsername);
  } else if (location.pathname === "/genealogy-tree") {
    ApiHook.CallGenealogyTreeList(treePlan, "", "", searchUsername);
  } else {
    //  Do nothing
  }
  const trimmedPathname = pathname.replace(/^\//, "");
  const plan = useSelector(
    (state) => state.dashboard?.appLayout?.moduleStatus?.mlm_plan
  );

  const handleChange = (e) => {
    const { value } = e.target;
    setUsername(value);
  };
  const handleSearch = () => {
    setSearchUsername(username);
  };
  const handleReset = () => {
    setSearchUsername("");
    setUsername("");
    setSelectedUserId("");
  }

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      // If Enter key is pressed, trigger the search
      handleSearch();
    }
  };
  const handleSideMenuToggle = () => {
    setSelectedMenu(!selectedMenu);
  };

  return (
    <>
      <div className="page_head_top">
        {t(menu)}
        <div className="right_btn_mob_toggle" onClick={handleSideMenuToggle}>
          <i className="fa fa-bars"></i>
        </div>
      </div>
      <div
        className={`tree_view_top_filter_bar mt-2 hide_show_mobile ${selectedMenu ? "show_mn" : ""
          }`}
      >
        <div className="row justify-content-between">
          <div
            className={`col-md-7 hide_show_mobile ${selectedMenu ? "show_mn" : ""
              }`}
          >
            <NavLink
              to="/genealogy-tree"
              className={({ isActive }) =>
                isActive ? "btn_ewallt_page active" : "btn_ewallt_page"
              }
            >
              {t("genealogyTree")}
            </NavLink>
            {plan !== "Unilevel" && (
              <NavLink
                to="/sponsor-tree"
                className={({ isActive }) =>
                  isActive ? "btn_ewallt_page active" : "btn_ewallt_page"
                }
              >
                {t("sponsorTree")}
              </NavLink>
            )}
            <NavLink
              to={"/tree-view"}
              className={({ isActive }) =>
                isActive ? "btn_ewallt_page active" : "btn_ewallt_page"
              }
            >
              {t("treeView")}
            </NavLink>
            <NavLink
              to={"/downline-members"}
              className={({ isActive }) =>
                isActive ? "btn_ewallt_page active" : "btn_ewallt_page"
              }
            >
              {t("downlineMembers")}
            </NavLink>
            {plan !== "Unilevel" && (
              <NavLink
                to={"/referral-members"}
                className={({ isActive }) =>
                  isActive ? "btn_ewallt_page active" : "btn_ewallt_page"
                }
              >
                {t("referralMembers")}
              </NavLink>
            )}
          </div>

          {(trimmedPathname === "genealogy-tree" ||
            trimmedPathname === "sponsor-tree") && (
              <>
                <div className="col-md-2 text-center ">
                  { /* userPlans?.planOptions.length > 1  && */ (
                    <div className="me-1">
                      {/* <Select
                        id={"plan"}
                        name={"plan"}
                        className={`dropdown-common`}

                        options={userPlans?.planOptions}
                        placeholder={"Select Plan"}
                        onChange={(e) => setTreePlan(e.value)}
                        value={userPlans?.planOptions.find(option => option.value === treePlan)}
                        isSearchable={false}
                      /> */}
                      {userPlans?.planOptions.length > 1 && <ConfigProvider
                        theme={{
                          token: {
                            colorPrimary: "#954cea", // 👈 your custom primary color
                            controlHeight: 38,       // 🔥 increases height of buttons, inputs, radios, etc.
                            borderRadius: 8,
                          },
                        }}
                      >

                        <Flex vertical gap="middle">
                          <Radio.Group
                            onChange={(e) => { handleTreePlanChange(e?.target?.value) }}
                            // block
                            options={userPlans?.planOptions}
                            defaultValue={defaultPlan}
                            optionType="button"
                            buttonStyle="solid"
                            value={treePlan}
                            disabled={isLoading}
                          />
                        </Flex>
                      </ConfigProvider>}

                    </div>
                  )}
                </div>
                <div className="col-md-3 mob_filter_right ">
                  <div className="right_search_div d-flex gap-1 nav-bar-flex">

                    <Form.Group>
                      <Form.Control
                        id="Search"
                        type="text"
                        placeholder={t("search")}
                        onChange={(e) => handleChange(e)}
                        onKeyPress={(e) => handleKeyPress(e)}
                        value={username}
                        required
                      />
                    </Form.Group>
                    <SubmitButton
                      className="btn btn-primary"
                      text="search"
                      click={handleSearch}
                    />
                    <SubmitButton
                      className="btn btn-secondary"
                      text="reset"
                      click={handleReset}
                    />
                  </div>
                </div>
              </>
            )}
          {((trimmedPathname === "tree-view" || trimmedPathname === "downline-members" || trimmedPathname === "referral-members") /* && userPlans?.planOptions.length > 1 */) && (
            <div className="col-md-4 mob_filter_right ">
              <div className="right_search_div d-flex gap-1 nav-bar-flex">

                <div>
                  {/* <Select
                    id={"plan"}
                    name={"plan"}
                    className={`dropdown-common`}

                    options={userPlans?.planOptions}
                    placeholder={"Select Plan"}
                    onChange={(e) => setTreePlan(e.value)}
                    value={userPlans?.planOptions.find(option => option.value === treePlan)}
                    isSearchable={false}
                  /> */}
                  {userPlans?.planOptions.length > 1 && <ConfigProvider
                    theme={{
                      token: {
                        colorPrimary: "#954cea", // 👈 your custom primary color
                        controlHeight: 38,       // 🔥 increases height of buttons, inputs, radios, etc.
                        borderRadius: 8,
                      },
                    }}
                  >

                    <Flex vertical gap="middle">
                      <Radio.Group
                        onChange={(e) => { handleTreePlanChange(e?.target?.value) }}
                        // block
                        options={userPlans?.planOptions}
                        defaultValue={defaultPlan}
                        optionType="button"
                        buttonStyle="solid"
                        value={treePlan}
                        disabled={isLoading}
                      />
                    </Flex>
                  </ConfigProvider>}

                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TreeViewNavbar;
